import styled, { createGlobalStyle } from 'styled-components';
import { PageTableWrapperStyled } from 'styles/common.styles';

// ─── Duplicate JD Modal: scoped global override ───────────────────────────────
export const DuplicateJdModalGlobal = createGlobalStyle`

  .duplicate-jd-modal .ant-btn-primary {
    background-color: ${p => p.theme?.colors?.primary ?? '#008080'} !important;
  }
`;

// ─── Status column filter: every status without an inner scroll ──────────────
// antd caps a filter menu at 264px (tableFilterDropdownHeight); the Status list (9 options) is a little taller.
export const STATUS_FILTER_DROPDOWN_CLASS = 'jd-status-filter-dropdown';
export const StatusFilterDropdownGlobal = createGlobalStyle`
  .${STATUS_FILTER_DROPDOWN_CLASS} .ant-table-filter-dropdown .ant-dropdown-menu {
    max-height: none;
  }
`;

// ─── Status cell: the status pill with the Retry link under it ────────────────
export const StatusCellStyled = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;


// ─── Search Wrapper ───────────────────────────────────────────────────────────

export const SearchWrapperStyled = styled.div`
  width: 460px;
  .ant-select {
    width: 100%;
  }
  /*
   * Ant Design places both allowClear (×) and suffixIcon in the same right-side
   * slot. When suffixIcon is an SbButton the × renders on top of it.
   * Offsetting .ant-select-clear pushes it left of the button so both are visible.
   */
  .ant-select-clear {
    right: 44px;
  }
`;

// ─── Jobs Table Wrapper ───────────────────────────────────────────────────────
// Extends the shared PageTableWrapperStyled with job-specific row states.

export const JobsTableWrapperStyled = styled(PageTableWrapperStyled)`
  /* Warm row hover — matches the PAIC tables (overrides the legacy cool hover from SbJobsLibrary.scss) */
  .jobs-table-content:hover > td {
    background: ${p => p.theme?.colors?.tableRowHoverBg ?? '#ECE5D8'} !important;
  }

  .jd-unpublished td {
    color: ${p => p.theme?.colors?.warningMessage ?? '#996A13'} !important;
  }

  .needs-revision-jd-row,
  .job-approval-pending {
    background-color: #ee9191 !important;
    td, th {
      color: ${p => p.theme?.colors?.warningMessage ?? '#996A13'} !important;
    }
  }

  /* ── Row: JD success / no-JD states ── */
  .jd-success-row {
    background-color: ${p => p.theme?.colors?.successBg ?? '#F5FBF8'};
    border: 2px solid ${p => p.theme?.colors?.successBorder ?? '#52BD94'};
  }

  .no-jd-row {
    background-color: ${p => p.theme?.colors?.warningBg ?? '#FFFAF1'};
    border: 2px solid ${p => p.theme?.colors?.warningBorder ?? '#FFB020'};
  }

  /* ── Row: progress fill animation (fill-bg) ── */
  .fill-bg {
    background-image: linear-gradient(to right, ${p => p.theme?.colors?.successBorder ?? '#52BD94'}, ${p => p.theme?.colors?.successBorder ?? '#52BD94'});
    background-repeat: no-repeat;
    background-position: left;
    background-size: var(--progress, 0%) 100%;
    transition: background-size 0.3s linear;

    td {
      color: ${p => p.theme?.colors?.warningMessage ?? '#996A13'} !important;
    }
  }
    
`;

// ─── Requisition nested table wrapper (light green tint) ─────────────────────

export const SbJobsCodeViewStyled = styled.div`
  margin-bottom: 0 !important;

  .ant-table-thead > tr > th {
    background: ${p => p.theme?.colors?.tableHeaderBg ?? '#F1ECE3'} !important;
  }

  .ant-table-tbody > tr > td {
    background: ${p => p.theme?.colors?.infoBg ?? '#EEFFFC'} !important;
    border-bottom-color: ${p => p.theme?.colors?.successBorder ?? '#52BD94'} !important;
  }
`;

// ─── Expand / collapse arrow ──────────────────────────────────────────────────

export const ExpandArrowStyled = styled.span`
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  cursor: pointer;

  &.down {
    border-top: 6px solid ${p => p.theme?.colors?.dark ?? '#2B3034'};
  }

  &.up {
    border-bottom: 6px solid ${p => p.theme?.colors?.dark ?? '#2B3034'};
  }
`;

// ─── No-expand dash (–) ──────────────────────────────────────────────────────

export const NoExpandDashStyled = styled.span`
  display: inline-block;
  position: relative;
  left: 3px;
`;

// ─── Duplicate Alert Wrapper ──────────────────────────────────────────────────

export const AlertWrapperStyled = styled.div`
  position: fixed;
  top: 80px;
  right: 24px;
  z-index: 4000;
  max-width: 360px;
`;

// ─── Guided-tour target wrapper ───────────────────────────────────────────────
// Inline-flex span so the tour spotlight hugs just the wrapped control (button /
// switch / search) rather than the whole header row.

export const TourTargetStyled = styled.span`
  display: inline-flex;
`;

// ─── "View By" toggle ─────────────────────────────────────────────────────────
// Matches the PAIC group page / Agent Library toggle: both mode labels stay
// visible and the active one is bolded.

export const ViewByLabelStyled = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ViewByTextStyled = styled.span`
  font-size: 18px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.dark : theme.colors.textLight};
`;
